export default __webpack_public_path__ + "3fe9101f8ad1789c9196230839675afe.gif";